import { getCompanyEntityAction, getCompanySuppliersAction } from '../../../../v2/APIs/action';
import { 
  SET_SUPPLIERS,
  SET_SELECTED_SUPPLIER,
  SET_SELECTED_ENTITY,
  SET_LOADING,
  SET_ERROR,
  CLEAR_ENTITY,
  SET_ENTITY,
  RESET_SUPPLIERS
} from '../../../Reducers/Entity/EntityReducer';

export const setSuppliers = (suppliers) => ({
  type: SET_SUPPLIERS,
  payload: suppliers,
});

export const setSelectedSupplier = (supplierId) => ({
  type: SET_SELECTED_SUPPLIER,
  payload: supplierId,
});


export const setSelectedEntity = (entityId) => ({
  type: SET_SELECTED_ENTITY,
  payload: entityId,
});

export const setEntity = (entityData) => ({
  type: SET_ENTITY,
  payload: entityData,
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading,
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error,
});

export const clearEntity = () => ({
  type: CLEAR_ENTITY,
});
export const resetSuppliers = () => ({
  type: RESET_SUPPLIERS,
});

// Legacy compatibility exports
export const resetEntityState = clearEntity;

export const fetchSuppliers = (module = 'default', params = {}) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error, message } = await getCompanySuppliersAction(module, params);
      if (!error && data && Array.isArray(data)) {
        dispatch(setSuppliers(data));
      } else {
        dispatch(setError(message || 'Failed to fetch entity data'));
      }
    } catch (err) {
      dispatch(setError(err.message || 'An error occurred'));
    }
  };
};

export const fetchEntity = (manufacturer_id, module_name = 'ALL_MODULES') => {
  return async (dispatch) => {
    try {
      dispatch(clearEntity());
      dispatch(setLoading(true));
      const params = { manufacturer_id, module_name };
      const { data, error, message } = await getCompanyEntityAction(params);
      if (!error && data && Array.isArray(data)) {
        dispatch(setEntity(data));
      } else {
        dispatch(setError(message || 'Failed to fetch entity data'));
      }
    } catch (err) {
      dispatch(setError(err.message || 'An error occurred'));
    }
  };
};